import { BaseEntity, DefaultResponseWithData } from "./system";

export enum WatermarkPosition {
  BottomLeft = 0,
  BottomRight = 1,
  TopLeft = 2,
  TopRight = 3,
  Center = 4,
  Diagonal = 5,
  Cover = 6
}

export interface IPartImageSettings extends BaseEntity {
  removeBackgrounds: boolean;
  numberToRemove: number;
  replaceExistingImages: boolean;
  applyWatermarks: boolean;
  grayscale: boolean;
  position: WatermarkPosition;
  transparency: number; // 0 = fully opaque, 99 = maximum transparency
}

export interface IPartImageSettingsResponse extends DefaultResponseWithData<IPartImageSettings> { }
